import { useCallback } from "react";

type SoundType = "critical" | "warning" | "important";

const criticalSound = new Audio(require("../assets/audio/criticalSound.m4a"));
const warningSound = new Audio(require("../assets/audio/warning.m4a"));
const importantSound = new Audio(require("../assets/audio/important.mp3"));
criticalSound.loop = true;
warningSound.loop = true;
importantSound.loop = false;
const sounds = {
  critical: criticalSound,
  warning: warningSound,
  important: importantSound,
};
const soundComponents: { [key in SoundType]: string[] } = {
  critical: [],
  warning: [],
  important: [],
};

export function useSound() {
  const play = useCallback((soundType: SoundType, componentId: string) => {
    if (!soundComponents[soundType].includes(componentId)) {
      soundComponents[soundType].push(componentId);
    }
    sounds[soundType].play();
  }, []);

  const stop = useCallback((soundType: SoundType, componentId: string) => {
    soundComponents[soundType] = soundComponents[soundType].filter(
      (id) => id !== componentId
    );

    if (soundComponents[soundType].length === 0) {
      sounds[soundType].pause();
      sounds[soundType].currentTime = 0; // Reset the sound to the beginning
    }
  }, []);

  const isPlaying = useCallback((soundType: SoundType) => {
    return soundComponents[soundType].length > 0;
  }, []);

  return { play, stop, isPlaying };
}
